export default __webpack_public_path__ + "static/media/SamYehHeadshot.70bf1587.jpg";